import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";
import { AssetsService } from "app/services/AssetsService";

import { StyledDescription, StyledEmptyStateContainer, StyledImage, StyledImageWrapper, StyledInner } from "./styles";
import type { SignalsEmptyStateProps } from "./types";

const SignalsEmptyState = (props: SignalsEmptyStateProps) => {
    const { signalType, onAddSignalClick } = props;

    const { translate } = useTranslate();

    return (
        <StyledEmptyStateContainer data-automation="signals-empty-state-wrapper">
            <StyledInner>
                <StyledImageWrapper>
                    <StyledImage
                        data-automation="signals-empty-state-image"
                        src={AssetsService.assetUrl("/images/sales-intelligence/signals-list.svg")}
                        alt="no signals available"
                    />
                </StyledImageWrapper>
                <I18n
                    data-automation="description-text"
                    element={StyledDescription}
                    translatable={{ key: signalsI18nKeys.emptyStateText(signalType) }}
                />
                {typeof onAddSignalClick === "function" ? (
                    <Button
                        dataAutomation="add-signal-button"
                        onClick={onAddSignalClick}
                    >
                        {translate(`si.signals.type.${signalType}.add-signal.text`)}
                    </Button>
                ) : null}
            </StyledInner>
        </StyledEmptyStateContainer>
    );
};

export default SignalsEmptyState;
